import React from "react";
import CustomAvatar from "../../shared/custom-avatar/custom-avatar";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col, Typography } from "antd";

import "./styles.scss";

const { Text } = Typography;

type PersonInfoPropsType = {
  name: string;
  //   imgSrc: string;
};

const PersonInfo = ({ name }: PersonInfoPropsType) => {
  return (
    <CustomRow align={"middle"}>
      <Col>
        <CustomAvatar imgSrc="https://i.pravatar.cc/300" size={40} />
      </Col>
      <Col className="ml-md">
        <Text className="PersonInfo-name">{name}</Text>
      </Col>
    </CustomRow>
  );
};

export default PersonInfo;
